import { Injectable, inject } from '@angular/core';
import { DeviceStoreActions } from '@era/stores';
import { Store } from '@ngrx/store';
import { DeviceState } from '@rocksoft/locations-sdk';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UnavailableDevicesResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    this.store.dispatch(
      DeviceStoreActions.DeviceResolverActions.devicesForStateRequested({
        state: DeviceState.Unavailable,
      })
    );
    return of(true);
  }
}
